import MyBread from "../../components/Breadcrumbs";
import React, {
  Fragment,
  useEffect,
  useState,
  Dispatch,
  SetStateAction,
} from "react";
import MaterialTable from "material-table";
import {
  ThemeProvider,
  createTheme,
  TableBody,
  TableCell,
  TableRow,
  CircularProgress,
} from "@mui/material";
import { useModal } from "react-hooks-use-modal";
import { useForm, SubmitHandler } from "react-hook-form";
import { useAuth } from "../../hooks/use-auth";
import axios from "axios";
import config from "config";
import ShareProcesses from "components/ShareProcesses";
import { Time, removeKeyWithValue } from "utils";
import IdSearchButton from "components/IdSearchButton";
import SubmitPerformances from "components/SubmitPerformances";
import AppearPerformances from "components/AppearPerformances";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { Edit, Delete, Share } from "@mui/icons-material";
import {
  Wrapper,
  PageTitle,
  CreateNew,
  ModalStyle,
  FormLabel,
  FormInput,
  FormLabelInputWrapper,
  ModalTitle,
  ModalForm,
  ModalSubmit,
  LoadingContainer,
  ModalClose,
  DivMargin,
} from "styles/styles";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";

interface ParentProps {
  data: ParentDataProps[];
  selectedId: number;
  setSelectedId: Dispatch<SetStateAction<number>>;
  setIsParentDataInsert: Dispatch<SetStateAction<boolean>>;
}

interface SetDataProps {
  (data: ChildDataProps[]): void;
}

interface ChildProps {
  data: ChildDataProps[];
  parentData: ParentDataProps[];
  setData: SetDataProps;
  setIsChildDataInsert: Dispatch<SetStateAction<boolean>>;
  selectedId: number;
}

interface ParentDataProps {
  records_product_number_id: number;
  records_order_id: number;
  serial_number: string;
  serial_number_branch: string;
  product_number_id: number;
  product_number_display_id: string;
  product_number_branch_id: number;
  product_number_branch_display_id: string;
  name: string;
  order_number: number;
  order_date: string;
  customer_deadline: string;
  internal_deadline: string;
  estimated_shipping_date: string;
  inventory_reservation: number;
  volume: number;
  unit_price: number;
  total_price: number;
  memo: string;
}

interface ChildDataProps {
  records_process_id: number;
  process_id: number;
  process_display_id: string;
  process_name: string;
  equipment_id: number;
  equipment_display_id: string;
  equipment_name: string;
  charged_user_id: number;
  charged_user_display_id: string;
  charged_user_name: string;
  volume: string;
  setup_time: string;
  tact_time: string;
  start_date: string;
  end_date: string;
  estimated_time: number;
  process_deadline: string;
  is_outsourcing: number;
  memo: string;
  tableData: {
    id: number;
  };
  [key: string]: string | number | Date | { id: number };
}

const Parent = ({ data, setSelectedId }: ParentProps) => {
  //arrayの生成
  const parentArray = [
    { title: "", field: "records_product_number_id" },
    { title: "受注管理No", field: "records_order_display_id" },
    { title: "製番", field: "serial_number" },
    { title: "製番_枝番", field: "serial_number_branch" },
    { title: "品番ID", field: "product_number_display_id" },
    { title: "品番_枝番", field: "product_number_branch_display_id" },
    { title: "品名", field: "name" },
    { title: "担当者ID", field: "charged_user_display_id" },
    { title: "担当者名", field: "charged_user_name" },
    { title: "工程完了数", field: "completed_number" },
    { title: "工程未完了数", field: "not_completed_number" },
    { title: "受注数", field: "order_number" },
    { title: "受注日", field: "order_date" },
    { title: "希望納期", field: "customer_deadline" },
    { title: "目標納期", field: "internal_deadline" },
    { title: "出荷予定日", field: "estimated_shipping_date" },
    { title: "在庫引当数量", field: "inventory_reservation" },
    { title: "製作数量", field: "volume" },
    { title: "単価", field: "unit_price" },
    { title: "金額", field: "total_price" },
    { title: "メモ", field: "memo" },
  ];
  const PAGE_TITLE = "受注情報";
  const columnsArray: any = [];
  for (const element of parentArray) {
    if (element.title) {
      columnsArray.push({
        title: element.title,
        field: element.field,
        cellStyle: {
          minWidth: 150,
          maxWidth: 150,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      });
    }
  }

  //カラムなど生成ここまで

  const [pageSize, setPageSize] = React.useState(5);
  const defaultMaterialTheme = createTheme();
  const [selectedRow, setSelectedRow] = useState(null);

  return (
    <>
      <ThemeProvider theme={defaultMaterialTheme}>
        <MaterialTable
          title={PAGE_TITLE}
          columns={columnsArray}
          data={data}
          options={{
            actionsColumnIndex: -1,
            headerStyle: { whiteSpace: "nowrap" },
            rowStyle: (rowData) => ({
              overflowWrap: "break-word",
              backgroundColor:
                selectedRow === rowData.tableData.id ? "#EEE" : "#FFF",
            }),
          }}
          onChangeRowsPerPage={(pageSize) => {
            setPageSize(pageSize);
          }}
          onRowClick={(event: any, rowData: any) => {
            event.preventDefault();
            setSelectedId(rowData.records_product_number_id);
            setSelectedRow(rowData.tableData.id);
          }}
        />
      </ThemeProvider>
    </>
  );
};

const Child = ({
  data,
  setData,
  parentData,
  setIsChildDataInsert,
  selectedId,
}: ChildProps) => {
  const auth = useAuth();
  const [selectedBranch, setSelectedBranch] = React.useState(0);
  const [isSubmitDisable, setIsSubmitDisable] = useState<boolean>(false);
  //modal
  const [pageSize, setPageSize] = React.useState(5);
  const [modalTitle, setModalTitle] = React.useState("");
  const [Modal, open, close, isOpen] = useModal("root", {
    preventScroll: true,
  });
  const {
    reset,
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm<ChildDataProps>();
  const onSubmit: SubmitHandler<ChildDataProps> = async (
    submitData: ChildDataProps
  ) => {
    let alertList: any[] = [];
    const requiredFields = parentArray
      .filter((obj) => obj.required === true)
      .map((obj) => obj.field);
    requiredFields.forEach((key) => {
      if (submitData[key] === undefined || submitData[key] === "") {
        alertList.push(key);
      }
    });
    if (alertList.length) {
      let text = "";
      parentArray.forEach((item) => {
        if (alertList.includes(item.field)) {
          text += `${item.title}を埋めてください。\n`;
        }
      });
      if (text !== "") {
        alert(text);
        throw new Error("必須項目が未入力です");
      }
    }

    /* submitDataで日付の部分がnullだと、仕様で文字列になってしまうため、対応 */
    if (submitData.start_date === "NaN-aN-aNTaN:aN") {
      submitData.start_date = "";
    }
    if (submitData.end_date === "NaN-aN-aNTaN:aN") {
      submitData.end_date = "";
    }
    /* ここまで */

    if (submitData.start_date > submitData.end_date) {
      window.alert("開始時刻は終了時刻より前にしてください");
      throw new Error("開始時刻は終了時刻より前にしてください");
    }

    submitData = removeKeyWithValue(submitData, "");
    const branchData = {
      is_ended: submitData.is_ended,
      process_id: submitData.process_id,
      process_display_id: submitData.process_display_id,
      process_name: submitData.process_name,
      equipment_id: submitData.equipment_id,
      equipment_display_id: submitData.equipment_display_id,
      equipment_name: submitData.equipment_name,
      charged_user_id: submitData.charged_user_id,
      charged_user_display_id: submitData.charged_user_display_id,
      charged_user_name: submitData.charged_user_name,
      volume: submitData.volume,
      setup_time: submitData.setup_time,
      tact_time: submitData.tact_time,
      start_date: submitData.start_date
        ? new Date(submitData.start_date).toISOString()
        : undefined,
      end_date: submitData.end_date
        ? new Date(submitData.end_date).toISOString()
        : undefined,
      estimated_time: submitData.estimated_time,
      process_deadline: submitData.process_deadline,
      memo: submitData.memo,
    };
    try {
      setIsSubmitDisable(true);
      if (!selectedBranch) {
        await axios.post(
          `/v0/records-product-numbers/${selectedId}/records-processes`,
          branchData,
          {
            headers: auth.authorizationHeader,
            params: { factory_id: auth.factoryId },
          }
        );
        window.alert("登録が完了しました");
      } else {
        await axios.patch(
          `/v0/records-product-numbers/${selectedId}/records-processes`,
          branchData,
          {
            headers: auth.authorizationHeader,
            params: {
              selected_branch: selectedBranch,
              factory_id: auth.factoryId,
            },
          }
        );
        window.alert("変更が完了しました");
      }
      close();
      setIsChildDataInsert(true);
    } catch (error: any) {
      window.alert(error.response.data.error);
    }
    setIsSubmitDisable(false);
  };
  //modal end

  //arrayの生成
  const parentArray = [
    { title: "", field: "records_process_id" },
    { title: "順番", default: "0", field: "number" },
    { title: "作業区分", field: "status", default: "未計画", disable: true },
    { title: "実績入力", field: "submit_performances", disable: true },
    { title: "終了フラグ", field: "is_ended", type: "checkbox" },
    { title: "", field: "process_id" },
    {
      title: "工程ID",
      field: "process_display_id",
      default: "",
      required: true,
      disable: true,
    },
    {
      title: "工程名称",
      field: "process_name",
      default: "",
      search: "processes",
      required: true,
      disable: true,
    },
    { title: "", field: "equipment_id" },
    {
      title: "設備ID",
      field: "equipment_display_id",
      default: "",
      disable: true,
    },
    {
      title: "設備名称",
      field: "equipment_name",
      default: "",
      search: "equipments",
      disable: true,
    },
    { title: "", field: "charged_user_id" },
    {
      title: "担当者ID",
      field: "charged_user_display_id",
      default: "",
      disable: true,
      required: true,
    },
    {
      title: "担当者名",
      field: "charged_user_name",
      default: "",
      disable: true,
      required: true,
      search: "users",
    },
    { title: "製作数量", field: "volume", default: "0", type: "number" },
    {
      title: "段取時間(分)",
      field: "setup_time",
      default: "0",
      type: "number",
    },
    {
      title: "タクトタイム(分)",
      field: "tact_time",
      default: "0",
      type: "number",
    },
    {
      title: "工程開始時刻",
      field: "start_date",
      default: "",
      type: "datetime-local",
    },
    {
      title: "工程終了時刻",
      field: "end_date",
      default: "",
      type: "datetime-local",
    },
    {
      title: "計画加工時間(分)",
      field: "estimated_time",
      default: "0",
      type: "number",
      required: true,
    },
    {
      title: "工程納期",
      field: "process_deadline",
      default: Time.format(new Date(), "YYYY-MM-DD"),
      type: "date",
    },
    {
      title: "共有したか否か",
      field: "is_outsourcing",
      type: "checkbox",
      disable: true,
    },
    { title: "メモ", field: "memo", default: "メモ", type: "text" },
    { title: "Actions", field: "actions" },
  ];
  const PAGE_TITLE = "工程登録";
  const defaultObj: any = {};
  for (const element of parentArray) {
    defaultObj[element.field] = element.default;
  }
  const columnsArray: any = [];

  for (const element of parentArray) {
    if (element.title) {
      const title = element.title;
      const field = element.field;
      const tmpObj = {
        title: title,
        field: field,
      };
      columnsArray.push(tmpObj);
    }
  }

  //検索BOX

  const [selectedProcessContents, setSelectedProcessContents] =
    useState<any>("");

  useEffect(() => {
    setValue("process_id", selectedProcessContents.process_id);
    setValue("process_display_id", selectedProcessContents.display_id);
    setValue("process_name", selectedProcessContents.name);
    setValue("equipment_id", selectedProcessContents.equipment_id);
    setValue(
      "equipment_display_id",
      selectedProcessContents.equipment_display_id
    );
    setValue("equipment_name", selectedProcessContents.equipment_name);
  }, [selectedProcessContents]);

  const [selectedEquipmentContents, setSelectedEquipmentContents] =
    useState<any>("");

  useEffect(() => {
    setValue("equipment_id", selectedEquipmentContents.equipment_id);
    setValue("equipment_display_id", selectedEquipmentContents.display_id);
    setValue("equipment_name", selectedEquipmentContents.name);
  }, [selectedEquipmentContents]);

  const [selectedUserContents, setSelectedUserContents] = useState<any>("");

  useEffect(() => {
    setValue("charged_user_id", selectedUserContents.user_id);
    setValue("charged_user_display_id", selectedUserContents.display_id);
    setValue("charged_user_name", selectedUserContents.name);
  }, [selectedUserContents]);

  const listItems = parentArray.map((element: any, index) => {
    if (
      element.title &&
      element.field !== "actions" &&
      element.field !== "number" &&
      element.field !== "submit_performances"
    ) {
      return (
        <Fragment key={index}>
          <FormLabelInputWrapper>
            <FormLabel htmlFor={element.field}>{element.title}</FormLabel>
            <FormInput
              {...register(element.field)}
              {...(element.type && {
                type: config.inputErrorMessage[element.type].type,
              })}
              {...(element.type && {
                placeholder: config.inputErrorMessage[element.type].placeholder,
              })}
              {...(element.type && {
                pattern: config.inputErrorMessage[element.type].pattern,
              })}
              {...(element.type && {
                title: config.inputErrorMessage[element.type].title,
              })}
              {...(element.required && { required: true })}
              {...(element.disable && { disabled: true })}
              {...(element.type && {
                maxLength: config.inputErrorMessage[element.type].maxLength,
              })}
              {...(element.type === "number" && {
                max: config.inputErrorMessage[element.type].max,
              })}
            />
            {element.search === "equipments" ? (
              <IdSearchButton
                search={element.search}
                setSelectedContents={setSelectedEquipmentContents}
              />
            ) : element.search === "processes" ? (
              <IdSearchButton
                search={element.search}
                setSelectedContents={setSelectedProcessContents}
              />
            ) : element.search === "users" ? (
              <IdSearchButton
                search={element.search}
                setSelectedContents={setSelectedUserContents}
              />
            ) : (
              <></>
            )}
          </FormLabelInputWrapper>
        </Fragment>
      );
    }
  });

  //カラムなど生成ここまで

  const defaultMaterialTheme = createTheme();

  /* 計画加工時間(分)を自動入力 */
  const volume: string = watch("volume");
  const setup_time: string = watch("setup_time");
  const tact_time: string = watch("tact_time");
  useEffect(() => {
    if (volume && setup_time && tact_time) {
      setValue(
        "estimated_time",
        parseInt(setup_time) + parseInt(tact_time) * parseInt(volume)
      );
    }
  }, [volume, setup_time, tact_time]);

  //IDから既存の値を呼び出し
  async function setModalValue(records_process_id: number) {
    if (!records_process_id) {
      setSelectedBranch(0);
      const currentData = parentData.filter(
        (item: { [key: string]: any }) =>
          parseInt(item["records_product_number_id"]) === selectedId
      );
      defaultObj.volume = currentData[0].volume;
      reset(defaultObj);
      setModalTitle("新規作成");
    } else {
      //データの取得axios
      try {
        setSelectedBranch(records_process_id);
        const result: any = await axios.get(
          `/v0/records-product-numbers/${selectedId}/records-processes`,
          {
            headers: auth.authorizationHeader,
            params: {
              selected_branch: records_process_id,
              factory_id: auth.factoryId,
            },
          }
        );
        result.data[0].end_date = Time.utcToHtmlDatetimeLocal(
          result.data[0].end_date
        );
        result.data[0].start_date = Time.utcToHtmlDatetimeLocal(
          result.data[0].start_date
        );
        result.data[0].is_outsourcing = parseInt(result.data[0].is_outsourcing);
        reset(result.data[0]);
        setModalTitle("編集");
      } catch (error) {
        console.log(error);
      }
    }
  }

  const createNew = async () => {
    await setModalValue(0);
    open();
  };

  const handleDragEnd = async (result: any) => {
    if (!result.destination) return;
    const items = Array.from(data);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    const output = items.map((item, index) => ({
      id: item.records_process_id,
      number: index + 1,
    }));
    const branchData = {
      data: output,
    };
    try {
      await axios.patch(
        `/v0/records-product-numbers/${selectedId}/update-numbers`,
        branchData,
        {
          headers: auth.authorizationHeader,
          params: {
            factory_id: auth.factoryId,
          },
        }
      );
      setData(items);
      setIsChildDataInsert(true);
    } catch (error: any) {
      window.alert(error.response.data.error);
    }
  };

  const handleEditClick = async (event: any, rowData: any) => {
    event.preventDefault();
    try {
      await setModalValue(rowData.records_process_id);
      open();
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteClick = async (event: any, rowData: any) => {
    event.preventDefault();
    const result = window.confirm(
      `${rowData.process_display_id}を削除しますか？`
    );
    if (result) {
      try {
        await axios.delete(
          `/v0/records-product-numbers/${selectedId}/records-processes`,
          {
            headers: auth.authorizationHeader,
            params: {
              selected_branch: rowData.records_process_id,
              factory_id: auth.factoryId,
            },
          }
        );
        setIsChildDataInsert(true);
      } catch (error: any) {
        window.alert(error.response.data.error);
      }
    }
  };

  const handleShareClick = (event: any, rowData: any) => {
    event.preventDefault();
    if (parseInt(rowData.is_outsourcing)) {
      window.alert("共有済みです。");
    } else if (parseInt(rowData.is_ended)) {
      window.alert("工程が終了しています。");
    } else {
      setShareProcessData(rowData);
      handleOpenNewComponent();
    }
  };

  function isConditionSatisfied(rowData: any, type: string): boolean {
    return (
      rowData.is_ended === 0 && rowData.status !== "未計画" && type === "submit"
    );
  }

  const renderRow = (row: any, index: number) => {
    return (
      <Draggable
        key={row.records_process_id.toString()}
        draggableId={row.records_process_id.toString()}
        index={index}
      >
        {(provided) => (
          <TableRow
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            <TableCell style={tableCell}>{index + 1}</TableCell>
            <TableCell style={tableCell}>{row.status}</TableCell>
            {isConditionSatisfied(row, "submit") ? (
              <TableCell style={tableCell}>
                <SubmitPerformances
                  selectedData={row}
                  setIsParentDataInsert={setIsChildDataInsert}
                  type={"span"}
                />
              </TableCell>
            ) : parseInt(row.is_ended) ? (
              <TableCell style={tableCell}>
                <AppearPerformances
                  processId={row.records_process_id}
                  processName={row.process_name}
                  equipmentName={row.equipment_name}
                  type={"span"}
                />
              </TableCell>
            ) : (
              <TableCell style={tableCell}></TableCell>
            )}
            <TableCell style={tableCell}>
              {parseInt(row.is_ended) ? (
                <CheckBoxIcon />
              ) : (
                <CheckBoxOutlineBlankIcon />
              )}
            </TableCell>
            <TableCell style={tableCell}>{row.process_display_id}</TableCell>
            <TableCell style={tableCell}>{row.process_name}</TableCell>
            <TableCell style={tableCell}>{row.equipment_display_id}</TableCell>
            <TableCell style={tableCell}>{row.equipment_name}</TableCell>
            <TableCell style={tableCell}>
              {row.charged_user_display_id}
            </TableCell>
            <TableCell style={tableCell}>{row.charged_user_name}</TableCell>
            <TableCell style={tableCell}>{row.volume}</TableCell>
            <TableCell style={tableCell}>{row.setup_time}</TableCell>
            <TableCell style={tableCell}>{row.tact_time}</TableCell>
            <TableCell style={tableCell}>{row.start_date}</TableCell>
            <TableCell style={tableCell}>{row.end_date}</TableCell>
            <TableCell style={tableCell}>{row.estimated_time}</TableCell>
            <TableCell style={tableCell}>{row.process_deadline}</TableCell>
            <TableCell style={tableCell}>
              {parseInt(row.is_outsourcing) ? (
                <CheckBoxIcon />
              ) : (
                <CheckBoxOutlineBlankIcon />
              )}
            </TableCell>
            <TableCell style={tableCell}>{row.memo}</TableCell>
            <TableCell style={tableCell}>
              <Edit onClick={(event) => handleEditClick(event, row)} />
              <Delete onClick={(event) => handleDeleteClick(event, row)} />
              <Share onClick={(event) => handleShareClick(event, row)} />
            </TableCell>
          </TableRow>
        )}
      </Draggable>
    );
  };

  const renderTableBody = () => {
    return (
      <Droppable droppableId="droppable">
        {(provided) => (
          <TableBody ref={provided.innerRef} {...provided.droppableProps}>
            {data.map((row, index) => renderRow(row, index))}
            {provided.placeholder}
          </TableBody>
        )}
      </Droppable>
    );
  };

  const [openNewComponent, setOpenNewComponent] = useState(false);
  const [shareProcessData, setShareProcessData] = useState<any>([]);

  const handleOpenNewComponent = () => {
    setOpenNewComponent(true);
  };

  return (
    <>
      {selectedId === 0 ? (
        ""
      ) : (
        <>
          <CreateNew onClick={createNew}>新規作成</CreateNew>
        </>
      )}
      <ThemeProvider theme={defaultMaterialTheme}>
        <DragDropContext onDragEnd={handleDragEnd}>
          <MaterialTable
            title={PAGE_TITLE}
            columns={columnsArray}
            data={data}
            options={{
              actionsColumnIndex: -1,
              paging: false,
              draggable: false,
              search: false,
              sorting: false,
              headerStyle: { whiteSpace: "nowrap" },
              rowStyle: { overflowWrap: "break-word" },
            }}
            components={{
              Body: () => renderTableBody(),
            }}
          />
        </DragDropContext>
      </ThemeProvider>

      {openNewComponent && !parseInt(shareProcessData.is_outsourcing) && (
        <ShareProcesses
          process_id={shareProcessData.records_process_id}
          volume={shareProcessData.volume}
          process_deadline={shareProcessData.process_deadline}
          process_name={shareProcessData.process_name}
          isModalOpen={openNewComponent}
          setIsModalOpen={setOpenNewComponent}
          setIsDataInsert={setIsChildDataInsert}
        />
      )}

      <Modal>
        <ModalStyle>
          <ModalTitle>{modalTitle}</ModalTitle>
          <ModalForm onSubmit={handleSubmit(onSubmit)}>
            {listItems}
            {isSubmitDisable ? (
              <LoadingContainer>
                <CircularProgress size={20} />
              </LoadingContainer>
            ) : (
              <ModalSubmit type="submit" disabled={isSubmitDisable} />
            )}
          </ModalForm>
          <ModalClose onClick={close}>CLOSE</ModalClose>
        </ModalStyle>
      </Modal>
    </>
  );
};

export default function ProductNumbers() {
  const auth = useAuth();
  const [isParentDataInsert, setIsParentDataInsert] = useState<boolean>(false);
  const [isChildDataInsert, setIsChildDataInsert] = useState<boolean>(false);
  const [parentData, setParentData] = useState<ParentDataProps[]>([]);
  const [childData, setChildData] = useState<ChildDataProps[]>([]);
  const [selectedId, setSelectedId] = useState<number>(0);

  useEffect(() => {
    try {
      axios
        .get(`/v0/factories/${auth.factoryId}/records-product-numbers`, {
          headers: auth.authorizationHeader,
        })
        .then((res: any) => {
          if (res.data.length) {
            setParentData(res.data);
          } else {
            setParentData([]);
          }
          setIsParentDataInsert(false);
        });
    } catch (err) {
      console.log(err);
    }
  }, [auth, isParentDataInsert]);

  useEffect(() => {
    if (selectedId === 0) {
      setChildData([]);
    } else {
      try {
        axios
          .get(`/v0/records-product-numbers/${selectedId}/records-processes`, {
            headers: auth.authorizationHeader,
            params: {
              factory_id: auth.factoryId,
            },
          })
          .then((res: any) => {
            if (res.data.length) {
              for (let i = 0; i < res.data.length; i++) {
                res.data[i].start_date = res.data[i].start_date
                  ? Time.utcToHtmlDatetimeLocal(res.data[i].start_date)
                  : "";
                res.data[i].end_date = res.data[i].end_date
                  ? Time.utcToHtmlDatetimeLocal(res.data[i].end_date)
                  : "";
              }
              setChildData(res.data);
            } else {
              setChildData([]);
            }
            setIsChildDataInsert(false);
          });
      } catch (err) {
        console.log(err);
      }
    }
  }, [auth, selectedId, isChildDataInsert]);

  return (
    <>
      <Wrapper>
        <MyBread />
        <PageTitle>工程登録/工程指示</PageTitle>
        <Parent
          data={parentData}
          selectedId={selectedId}
          setSelectedId={setSelectedId}
          setIsParentDataInsert={setIsParentDataInsert}
        />
        <DivMargin></DivMargin>
        <Child
          data={childData}
          setData={setChildData}
          parentData={parentData}
          selectedId={selectedId}
          setIsChildDataInsert={setIsChildDataInsert}
        />
      </Wrapper>
    </>
  );
}

const tableCell = {
  maxWidth: "150px",
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap" as "nowrap",
};
